"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "theme", {
  enumerable: true,
  get: function get() {
    return _normal["default"];
  }
});
Object.defineProperty(exports, "displayName", {
  enumerable: true,
  get: function get() {
    return _identifiers.QUESTION_MULTIPLE_CHOICE;
  }
});
Object.defineProperty(exports, "identifier", {
  enumerable: true,
  get: function get() {
    return _identifiers.QUESTION_MULTIPLE_CHOICE;
  }
});
exports["default"] = exports.QuestionMultipleChoice = void 0;

var _normal = _interopRequireDefault(require("./_normal.scss"));

var _identifiers = require("../identifiers");

var _Question = _interopRequireDefault(require("../Question"));

var _factory = _interopRequireDefault(require("./factory"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var params = {
  identifier: _identifiers.QUESTION_MULTIPLE_CHOICE,
  Question: _Question["default"]
};
var QuestionMultipleChoice = (0, _factory["default"])(params);
exports.QuestionMultipleChoice = QuestionMultipleChoice;
var _default = QuestionMultipleChoice;
exports["default"] = _default;